module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "action-buttons"
  }, [_c('b-form-group', {
    staticClass: "pull-right"
  }, [_c('b-button-group', [(!_vm.disablePrevious) ? _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "type": "button",
      "variant": "outline-secondary",
      "title": "Vorige"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('previous-item')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-angle-double-left"
  })]) : _vm._e(), _vm._v(" "), (!_vm.disableNext) ? _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "type": "button",
      "variant": "outline-secondary",
      "title": "Volgende"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('next-item')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-angle-double-right"
  })]) : _vm._e()], 1), _vm._v(" "), _c('b-button-group', [(!_vm.disableDelete) ? _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "type": "button",
      "variant": "danger",
      "title": "Verwijderen"
    },
    on: {
      "click": _vm.showDeleteModal
    }
  }, [_c('fa-icon', {
    attrs: {
      "icon": "trash"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('b-button-group', [_c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "right": "",
      "type": "submit",
      "variant": "primary",
      "title": "Opslaan"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-save"
  })]), _vm._v(" "), (!_vm.disableSaveAndNew) ? _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "type": "button",
      "variant": "primary",
      "title": "Opslaan en nieuw"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('save-and-new')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus"
  })]) : _vm._e(), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "type": "button",
      "variant": "primary",
      "title": "Opslaan en terug"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('save-and-back')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-reply"
  })])], 1), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "type": "button",
      "variant": "outline-secondary",
      "title": "Terug"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('back')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-reply"
  })])], 1), _vm._v(" "), _c('delete-dialog-modal', {
    ref: "deleteModal",
    attrs: {
      "delete-name": _vm.deleteName,
      "is-deleting": _vm.isDeleting
    },
    on: {
      "confirm": function($event) {
        return _vm.$emit('delete')
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d924c8e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/Edit/ActionButtons.vue
// module id = 1315
// module chunks = 1